var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-box mb-16"},[_c('img',{staticClass:"mb-4",attrs:{"src":require('../../assets/logo-go-ral.png'),"width":"320"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }